"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.logicalNode = void 0;
exports.logicalNode = {
    hasChildNodes: false,
    getEvaluatorFunction: ({ node }) => {
        return () => ({
            node,
            inputs: [],
            output: { error: null, result: node.value },
        });
    },
};
//# sourceMappingURL=logical.js.map